import { GameState } from "./GameState";

export class StatCardData {
    label: string;
    isStatVisible: (gameState: GameState) => boolean;
    props: {
        label: string;
        value: string;
        storageInfo?: string;
        progress?: number;
        valueColor?: string;
        extraInfo?: string;
        progressColor?: string;
    };
    constructor(params: {
        label: string;
        isStatVisible: (gameState: GameState) => boolean;
        props: {
            label: string;
            value: string;
            storageInfo?: string;
            progress?: number;
            valueColor?: string;
            extraInfo?: string;
            progressColor?: string;
        };
    }) {
        this.label = params.label;
        this.isStatVisible = params.isStatVisible;
        this.props = params.props;
    }
}